// extracted by mini-css-extract-plugin
export default {"startScreen":"StartScreen_startScreen__yRJhO"};